import { render, staticRenderFns } from "./BackPassword.vue?vue&type=template&id=b3dd3c38&scoped=true&"
import script from "./BackPassword.vue?vue&type=script&lang=js&"
export * from "./BackPassword.vue?vue&type=script&lang=js&"
import style0 from "./BackPassword.vue?vue&type=style&index=0&id=b3dd3c38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dd3c38",
  null
  
)

export default component.exports